export default "__VITE_ASSET__KjM0IsNk__"